/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type MarkHardwareRequestAsPickedUpMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type MarkHardwareRequestAsPickedUpMutation = {
  markHardwareRequestAsPickedUp: Pick<
    Types.HardwareRequest,
    "id" | "status" | "user_id" | "event_id"
  > & {
    user: Pick<Types.User, "id" | "name" | "email">;
    hardware_item_requests: Array<
      Pick<Types.HardwareItemRequest, "id" | "quantity"> & {
        HardwareItem: Pick<
          Types.HardwareItem,
          "id" | "sku_code" | "total_quantity" | "available_quantity"
        >;
      }
    >;
  };
};

export const MarkHardwareRequestAsPickedUpDocument = gql`
  mutation MarkHardwareRequestAsPickedUp($id: Float!) {
    markHardwareRequestAsPickedUp(id: $id) {
      id
      status
      user_id
      event_id
      user {
        id
        name
        email
      }
      hardware_item_requests {
        id
        quantity
        HardwareItem {
          id
          sku_code
          total_quantity
          available_quantity
        }
      }
    }
  }
`;

/**
 * __useMarkHardwareRequestAsPickedUpMutation__
 *
 * To run a mutation, you first call `useMarkHardwareRequestAsPickedUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkHardwareRequestAsPickedUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markHardwareRequestAsPickedUpMutation, { data, loading, error }] = useMarkHardwareRequestAsPickedUpMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkHardwareRequestAsPickedUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    MarkHardwareRequestAsPickedUpMutation,
    MarkHardwareRequestAsPickedUpMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    MarkHardwareRequestAsPickedUpMutation,
    MarkHardwareRequestAsPickedUpMutationVariables
  >(MarkHardwareRequestAsPickedUpDocument, baseOptions);
}
export type MarkHardwareRequestAsPickedUpMutationHookResult = ReturnType<
  typeof useMarkHardwareRequestAsPickedUpMutation
>;
export type MarkHardwareRequestAsPickedUpMutationResult =
  ApolloReactCommon.MutationResult<MarkHardwareRequestAsPickedUpMutation>;
export type MarkHardwareRequestAsPickedUpMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    MarkHardwareRequestAsPickedUpMutation,
    MarkHardwareRequestAsPickedUpMutationVariables
  >;
